import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Tab, Tabs } from 'material-ui/Tabs'
import Reminders from './Reminders'
import Reviews from './Reviews'

const tabStyles = {
  tab: {
    backgroundColor: 'white',
    color: 'black',
  },
  activeTab: {
    backgroundColor: '#2A9CB9',
    color: 'white',
  },
  underline: {
    height: '4px',
    marginTop: '-4px',
    backgroundColor: 'unset',
  },
}

class Dashboard extends Component {
  state = {
    currentSelectedTab: 'reminders',
  }

  toggleTabs = (value) => {
    this.setState({ currentSelectedTab: value })
  }

  createStyles = () => {
    const { currentSelectedTab } = this.state
    return ['reminders', 'reviews']
      .reduce((acc, tab) => {
        acc[`${tab}`] = tab === currentSelectedTab ? tabStyles.activeTab : tabStyles.tab
        return acc
      }, {})
  }

  render() {
    const { currentSelectedTab } = this.state
    const {
      hasReminders,
      hasTopsRemindersPlus,
      hasReviews,
    } = this.props
    const styles = this.createStyles()
    if (!hasReminders && !hasTopsRemindersPlus) {
      return <Reviews />
    } else if (!hasReviews && !hasTopsRemindersPlus) {
      return <Reminders />
    }

    return (
      <Tabs
        value={currentSelectedTab}
        onChange={this.toggleTabs}
        inkBarStyle={tabStyles.underline}
      >
        <Tab
          style={styles.reminders}
          label="Reminders"
          value="reminders"
        >
          <Reminders />
        </Tab>
        <Tab
          style={styles.reviews}
          label="Reviews"
          value="reviews"
        >
          <Reviews />
        </Tab>
      </Tabs>
    )
  }
}


const mapStateToProps = ({
  account: {
    auth: {
      hasReviews,
      hasReminders,
      hasTopsRemindersPlus,
    },
  },
}) => ({
  hasReviews,
  hasReminders,
  hasTopsRemindersPlus,
})

Dashboard.defaultProps = {
  hasReviews: false,
  hasReminders: false,
  hasTopsRemindersPlus: false,
}

Dashboard.propTypes = {
  hasReviews: PropTypes.bool.isRequired,
  hasReminders: PropTypes.bool.isRequired,
  hasTopsRemindersPlus: PropTypes.bool.isRequired,
}

export default connect(mapStateToProps, null)(Dashboard)



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js